import AccordionSection from 'components/BaseHelpers/AccordionSection';

import { ComponentProps } from '../../../types/component-props';
import { CoreAccordionData } from '../../../types/components';

export type CoreAccordionProps = ComponentProps & CoreAccordionData;

const CoreAccordion = (props: CoreAccordionProps): JSX.Element => {
  return <AccordionSection {...props.fields} />;
};

export default CoreAccordion;
